import classNames from 'classnames'
import React from 'react'
import c from '../../classnames.scss'
import {SummaryProps} from './interfaces'
import {SummaryDivider} from './summary-divider'
import s from './summary.scss'
import {TicketsSummary} from './tickets-summary'

export const Summary = ({title, date, location, ticketedEvent}: SummaryProps) => {
  return (
    <div className={classNames(s.summary, c.formSummaryBox, c.formSummaryColor)} id="event-summary">
      <div className={s.container}>
        <div className={s.info}>
          <div className={classNames(s.title, c.formSummaryTitle)} data-hook="event-title">
            {title}
          </div>
          <SummaryDivider />
          <div className={c.formSummaryBody}>
            <div data-hook="event-time">{date}</div>
            <div data-hook="event-location">{location}</div>
          </div>
        </div>
      </div>
      {ticketedEvent && <TicketsSummary />}
    </div>
  )
}
